<template>
  <div>行为日志</div>
</template>
<script>
export default {}
</script>
<style lang="less"></style>
